//#region ../erd-editor-schema/dist/v2/schema/relationshipEntity.js
var RelationshipType = {
	ZeroOneN: "ZeroOneN",
	ZeroOne: "ZeroOne",
	ZeroN: "ZeroN",
	OneOnly: "OneOnly",
	OneN: "OneN",
	One: "One",
	N: "N"
};
var RelationshipTypeList = Object.values(RelationshipType);
var StartRelationshipType = {
	Ring: "Ring",
	Dash: "Dash"
};
var StartRelationshipTypeList = Object.values(StartRelationshipType);
var Direction = {
	left: "left",
	right: "right",
	top: "top",
	bottom: "bottom"
};
var DirectionList = Object.values(Direction);
//#endregion
export { Direction, DirectionList, RelationshipType, RelationshipTypeList, StartRelationshipType, StartRelationshipTypeList };
